export default "__VITE_ASSET__Dhug1yjx__"